import { useTranslation } from 'next-i18next'
import Card from '../../../Card'
import { HeroIcons } from '../../../../lib/utils/heroIcons'
import React from 'react'

export default function HelpCard() {
  const { t } = useTranslation('originals/property')

  return (
    <Card className="relative border border-neutralGray/50 bg-neutralWhite p-3">
      <div className="flex items-start">
        <div>
          <HeroIcons.InformationCircleIcon className="mr-1 h-auto w-5 text-neutralBlack/80" />
        </div>
        <div>
          <div className="mb-3">
            <div className="text-sm font-medium text-neutralBlack/80">
              {t('blockchainSection.helpCard.title')}
            </div>
            <div className="text-sm font-normal text-neutralBlack/70">
              {t('blockchainSection.helpCard.subtitle')}
            </div>
          </div>

          <div>
            <ul className="space-y-1 text-sm text-neutralBlack/70">
              <li>
                <strong className="font-medium text-neutralBlack/80">
                  {t('blockchainSection.helpCard.sovereign.title')}
                </strong>{' '}
                {t('blockchainSection.helpCard.sovereign.text')}
              </li>
              <li>
                <strong className="font-medium text-neutralBlack/80">
                  {t('blockchainSection.helpCard.transparent.title')}
                </strong>{' '}
                {t('blockchainSection.helpCard.transparent.text')}
              </li>
              <li>
                <strong className="font-medium text-neutralBlack/80">
                  {t('blockchainSection.helpCard.security.title')}
                </strong>{' '}
                {t('blockchainSection.helpCard.security.text')}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Card>
  )
}
